import { put } from 'redux-saga/effects'
import * as Actions from './actions'

export function* getTipo(value) {
    try {
        yield put(Actions.setTipo(value));
    } catch (error) {
    }
}
